import React from 'react'
import type { Icon } from 'shared/utils'
export const CircleHotDrink = (props: Icon) => {
    const {
        color = 'black',
        background = '#A11A2C',
        size = 32,
        className = 'circle-hot-drink',
        ...otherProps
    } = props
    const transform = `translate(${(size - 24) / 2} ${(size - 24) / 2})`
    return (
        <svg
            width={size}
            height={size}
            fill={color}
            className={className}
            {...otherProps}>
            <circle
                cx={size / 2}
                cy={size / 2}
                r={size / 2}
                fill={background}
            />
            <path
                transform={transform}
                d="M5.872 5.23c-.604-.1-.742-.247-.818-.86-.023-.19-.057-.38-.054-.57.006-.338.154-.473.487-.478h.03c.455 0 .742-.225.86-.677.147-.553.305-.646.878-.642 2.616.021 5.232.032 7.848.038.768.001 1.534-.035 2.302-.04.25-.002.506.013.75.068.113.026.263.15.288.256.129.527.352.889.984.845.257-.018.427.176.43.454.003.31.033.628-.035.923-.037.16-.256.277-.387.416-.072.077-.183.156-.195.244-.073.57-.754 6.606-.824 7.775-.079 1.34-.59 6.773-.692 8.111a.633.633 0 01-.48.594c-.453.126-.916.296-1.376.304-1.786.025-3.573-.008-5.358-.019a8.44 8.44 0 01-2.493-.394c-.38-.12-.758-.29-.824-.745-.07-.482-.088-.973-.136-1.46-.093-.952-.2-1.903-.283-2.856-.045-.512-.041-.614-.082-1.126-.087-1.115-.615-6.326-.666-7.151-.04-.663-.109-1.327-.15-1.99-.02-.331-.002-.664-.002-1.019h-.002zm6.889-.377v-.011c1.182 0 2.365.023 3.546-.007a40.469 40.469 0 002.71-.176c.403-.037.486-.22.445-.79-.024-.338-.292-.359-.536-.353-1.413.033-2.825.077-4.238.124-.266.008-.509.082-.692.31-.22.273-.534.343-.851.261-.366-.094-.714-.25-1.074-.37-.236-.078-.477-.198-.715-.198-1.759.005-3.515.032-5.274.063-.616.011-.708.161-.58.766.056.267.184.38.448.377.471-.004.944.003 1.415.003h5.395v.001zm5.454-1.764c-.11-.54-.253-.681-.744-.681-1.514 0-3.028.02-4.544.021-1.907.002-3.816-.008-5.724-.006-.105 0-.264.04-.3.11-.128.247-.211.516-.304.758 1.501-.02 2.994-.035 4.486-.067.553-.012 1.044.081 1.481.464.363.316.836.217 1.177-.1.188-.174.45-.336.694-.364.72-.082 1.448-.106 2.173-.132.534-.018 1.067-.004 1.605-.004v.001z"
                fillRule="nonzero"
            />
        </svg>
    )
}
